export const validateIdentifier = (id: string) => {
  const regex = new RegExp('^[A-Za-z0-9_\\-.]*$');
  if (regex.test(id)) {
    return true;
  }
  return false;
};
